import { PipeTransform, Injectable, Pipe } from '@angular/core';
import { AppConfig } from "@app/config";

@Pipe({
  name: 'imageUrl'
})
@Injectable()
export class ImageUrlPipe implements PipeTransform {

  constructor() {
  }
    
  public transform(input: any, size: string = null): string {
    
    if (input === null) return null;
    let url = AppConfig.apiBaseUrl + '/upload/image/';
    
    if(size !== null){
      url += size + '/';
    }
    
    url += input;
    
    return url;


  }
}



// WEBPACK FOOTER //
// ./src/pipes/imageUrl.ts